import Endpoints from '@commons/communication/endpoints.js'

export default{
    mixins:[Endpoints],
    computed:{
        basket:function () {
            return this.$store.getters.getBasket;
        }
    },
    methods:{
        changeQuantity: function(be){
            var self = this;
            this.connBasketChangeQuantity(be.id,be.quantity,function (r) {
                self.$store.commit('setBasket',r.data);
            },function (r) {
                if (r.data.errorCode == 1207){
                    toastr.warning('Túllépted a maximális súlyhatárt.');
                }
                if (r.data.errorCode == 1203){
                    toastr.warning('A termékből nem áll rendelkezésre a kívánt mennyiség.');
                }
            })
        },
        removeElement:function (be) {
            var self = this;
            this.connBasketRemoveElement(be.id,function (r) {
                self.$store.commit('setBasket',r.data);
            })
        },
        clearBasket:function () {
            var self = this;
            this.connBasketClear(function (r) {
                self.$store.commit('setBasket',r.data);
            })
        },
        increment:function (be) {
            var step = be.product.additionalFields.minOrderQuantity == 0?1:be.product.additionalFields.minOrderQuantity;
            var max = be.product.availableQuantity;

            if (be.quantity+step<=max){
                be.quantity+=step;
                this.changeQuantity(be);
            }
        },
        decrement:function (be) {
            var step = be.product.additionalFields.minOrderQuantity == 0?1:be.product.additionalFields.minOrderQuantity;

            if (be.quantity-step>=step){
                be.quantity-=step;
                this.changeQuantity(be);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/components/pages/dashboard/basket/Basket.js